import React from 'react';
import { map } from 'lodash';

const ProductImagery = ({ images }) => (
  <section className="product-page__imagery">
    <div className="product-imagery">
      <div className="product-main-images">
        {map(images, (image, i) =>
          <div className="product-main-images__image" key={i} id={`image-${i}`}>
            <img src={image.src} alt={image.alt} />
          </div>
        )}
      </div>
      <div className="product-preview-images">
        <div className="product-preview-images__container">
          {map(images, (image, i) =>
            <a
              key={i}
              href={`#image-${i}`}
              id={`image-${i}`}
              className="product-preview-images__image"
              style={{'backgroundImage': `url(${image.src})`}}
            >
              <img src={image.src} alt={image.alt} />
            </a>
          )}
        </div>
      </div>
    </div>
  </section>
);

export default ProductImagery;


// WEBPACK FOOTER //
// ./assets/scripts/components/Product/ProductImagery.js